module.exports = __webpack_public_path__ + "assets/TDropPerp.a85ba7121ea5b6d8b637f0be661adb28.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TDropPerp.gmt
// module id = 1010
// module chunks = 0